import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { Ionic2RatingModule } from 'ionic2-rating';
import { PipesModule } from '../../../pipes/pipes.module';
import { EventPollMessageComponent } from './event-poll-message/event-poll-message';
import { EventPollQuestionsComponent } from './event-poll-questions/event-poll-questions';
import { EventRatingQuestionComponent } from './event-poll-questions/event-rating-question/event-rating-question';
import { EventOpenQuestionComponent } from './event-poll-questions/event-open-question/event-open-question';
import { EventSingleQuestionComponent } from './event-poll-questions/event-single-question/event-single-question';
import { EventMultipleQuestionComponent } from './event-poll-questions/event-multiple-question/event-multiple-question';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    IonicModule,
    Ionic2RatingModule,
    PipesModule,
    TranslateModule
  ],
  exports: [
    EventPollMessageComponent,
    EventPollQuestionsComponent,
    EventRatingQuestionComponent,
    EventOpenQuestionComponent,
    EventSingleQuestionComponent,
    EventMultipleQuestionComponent,
  ],
  declarations: [
    EventPollMessageComponent,
    EventPollQuestionsComponent,
    EventRatingQuestionComponent,
    EventOpenQuestionComponent,
    EventSingleQuestionComponent,
    EventMultipleQuestionComponent
  ],
  providers: [],
})
export class PollEventComponentsModule { }



// WEBPACK FOOTER //
// ./src/pages/poll-event/components/poll-events-components.module.ts